import { render } from "./ShortText.vue?vue&type=template&id=0f119295"
import script from "./ShortText.vue?vue&type=script&lang=js"
export * from "./ShortText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__